
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vuetifyToast from 'vuetify-toast';
import './BookingInfoDialog.scss'
import Booking from '@/components/Booking/models/Booking';
import moment from 'moment';
import { BookingStates } from '@/components/Booking/models/BookingStates';
import { Destination } from '@/components/Passenger/models/Destination';

@Component
export default class BookingInfoDialog extends Vue {
	static EVENT_BOOKING_INFO_DIALOG_OPEN = "EVENT_BOOKING_INFO_DIALOG_OPEN";

	show: boolean = false;
	booking: Booking = null;
	$t: any;
	$dateHelper: any;

	get destination(): Destination {
		return this.$store.state.destination.destinations.find(d => d.id === this.booking.destinationId);
	}

	isValidDate(date: Date): boolean {
		return date.getTime() > 946684800000;
	}

	formatDate(date: Date): string {
		return moment(date).locale(this.$i18n.locale()).format('LLL');
	}

	created() {
		this.$root.$on(BookingInfoDialog.EVENT_BOOKING_INFO_DIALOG_OPEN, this.onOpenDialog);
	}

	onOpenDialog(booking: Booking) {
		this.booking = booking;
		this.show = true;
	}

	onCloseClick() {
		this.show = false;
	}

	beforeDestroy() {
		this.$root.$off(BookingInfoDialog.EVENT_BOOKING_INFO_DIALOG_OPEN, this.onOpenDialog);
	}
}
